var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9867 0C30.7067 0 18.2933 0 32.0133 0C45.7333 0 49 3.26667 49 16.9867C49 30.7067 49 18.2933 49 32.0133C49 45.7333 45.7333 49 32.0133 49C18.2933 49 30.7067 49 16.9867 49C3.26667 49 0 45.7333 0 32.0133C0 18.2933 0 24.6481 0 16.9867C0 3.26667 3.26667 0 16.9867 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1274 16.8811C40.3545 16.124 40.1274 15.5677 39.047 15.5677H35.474C34.5656 15.5677 34.1467 16.0483 33.9196 16.5782C33.9196 16.5782 32.1026 21.007 29.5287 23.8838C28.696 24.7165 28.3174 24.9815 27.8632 24.9815C27.6361 24.9815 27.3073 24.7165 27.3073 23.9595V16.8811C27.3073 15.9726 27.0437 15.5677 26.2865 15.5677H20.672C20.1042 15.5677 19.7628 15.9894 19.7628 16.389C19.7628 17.2502 21.0497 17.4488 21.1824 19.8714V25.1329C21.1824 26.2865 20.974 26.4956 20.5198 26.4956C19.3086 26.4956 16.3622 22.0471 14.6148 16.9568C14.2723 15.9674 13.9288 15.5677 13.0157 15.5677H9.44279C8.42195 15.5677 8.21777 16.0483 8.21777 16.5782C8.21777 17.5246 9.42907 22.2183 13.8578 28.4261C16.8102 32.6655 20.97 34.9636 24.7553 34.9636C27.0264 34.9636 27.3074 34.4532 27.3074 33.574V30.3698C27.3074 29.349 27.5225 29.1453 28.2417 29.1453C28.7716 29.1453 29.6801 29.4102 31.7999 31.4543C34.2224 33.8768 34.6218 34.9636 35.9845 34.9636H39.5574C40.5782 34.9636 41.0886 34.4532 40.7942 33.4459C40.472 32.442 39.3153 30.9854 37.7806 29.2588C36.9478 28.2747 35.6987 27.2148 35.3201 26.6848C34.7902 26.0035 34.9416 25.7007 35.3201 25.0951C35.3201 25.0951 39.6732 18.963 40.1274 16.8811Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogo);
export default __webpack_public_path__ + "static/media/vk-logo.c16484ab393618391a0d9a1dff5c28c6.svg";
export { ForwardRef as ReactComponent };